/* istanbul ignore file */
import { FormTemplate, DateInput, SubmitFormButton } from 'framework/form';
import budgetReportFiltersValidation from 'domain/finance/budget/report/List/budgetReportFiltersValidation';
import { LoadingFormLayout, FormRow } from 'framework/ui/layout';
import useBudgetReportService from 'domain/finance/budget/report/shared/budgetReportService';
import { ListHeader, ListPageLayout } from 'framework/list';
import { downloadFile } from 'framework/utils';

const BudgetReportList = () => {
  const { getReport } = useBudgetReportService();

  return (
    <ListPageLayout header={<ListHeader label="Budgets Report" icon="fa-clock-o" />}>
      <FormTemplate
        submitFormFunc={data => getReport(data).then(resp => downloadFile(resp))}
        getValidationSchemaFunc={() => Promise.resolve(budgetReportFiltersValidation)}
        handleDirty={false}
      >
        <FormRow colXl={2}>
          <DateInput label="Period from" source="from" />
          <DateInput label="To" source="to" />
        </FormRow>

        <SubmitFormButton>Generate</SubmitFormButton>

        <LoadingFormLayout />
      </FormTemplate>
    </ListPageLayout>
  );
};

export default BudgetReportList;
